
import {
  defineComponent,
  PropType,
} from 'vue';
import { useStore } from 'vuex';
import Product from '@/classes/Product';
import { formatNumber } from '@/helpers';

export default defineComponent({
  props: {
    itemKey: {
      type: String,
      required: true,
    },
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    isOrderCancel: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },

  emits: ['clear', 'approved'],

  setup(props, context) {
    const store = useStore();

    const onApprove = () => {
      store.dispatch('cart/remove', {
        key: props.itemKey,
        product: props.product,
      }).then(() => {
        context.emit('approved');
      });
    };

    return {
      formatNumber,
      onApprove,
    };
  },
});
